import React from 'react'
import AdminEditorCheckboxes from './AdminEditorCheckboxes'
import AuthorCheckboxes from './AuthorCheckboxes'

const RecipientCheckboxes = ({ recipientType, users, handleSelectAdmin, recipients }) => {
  if (recipientType === 'authors') {
    return (
      <AuthorCheckboxes
        users={users}
        handleSelectAdmin={handleSelectAdmin}
        recipients={recipients}
      />
    )
  } else {
    return (
      <AdminEditorCheckboxes
        users={users}
        handleSelectAdmin={handleSelectAdmin}
        recipients={recipients}
      />
    )
  }
}

export default RecipientCheckboxes


